<template>
  <form novalidate="true" @submit.prevent="submit">
    <b-field
      label="Numéro*"
      :message="fields.number.error"
      :type="fields.number.error !== null ? 'is-danger' : ''"
    >
      <b-input
        v-model="fields.number.value"
        type="text"
        :icon-right="fields.number.value ? 'close-circle' : ''"
        :icon-right-clickable="!!fields.number.value"
        @icon-right-click="fields.number.value = null"
      />
    </b-field>
    <b-field
      label="IMEI*"
      :message="fields.imei.error"
      :type="fields.imei.error !== null ? 'is-danger' : ''"
    >
      <b-input
        v-model="fields.imei.value"
        type="text"
        :icon-right="fields.imei.value ? 'close-circle' : ''"
        :icon-right-clickable="!!fields.imei.value"
        @icon-right-click="fields.imei.value = null"
      />
    </b-field>
    <b-field
      label="Date d'achat*"
      :message="fields.purchasedAt.error"
      :type="fields.purchasedAt.error !== null ? 'is-danger' : ''"
    >
      <b-datepicker
        v-model="fields.purchasedAt.value"
        placeholder="Type or select a date..."
        icon="calendar-day"
        :date-formatter="dateFormat"
      />
    </b-field>
    <b-field
      label="Propriétaire*"
      :message="fields.owner.error"
      :type="fields.owner.error !== null ? 'is-danger' : ''"
    >
      <b-select v-model="fields.owner.value" label="Choisir un propriétaire" icon="user" expanded>
        <option v-for="owner in owners" :key="owner" :value="owner">
          {{ capitalize(owner) }}
        </option>
      </b-select>
    </b-field>
    <b-field
      label="Modèle*"
      :message="fields.model.error"
      :type="fields.model.error !== null ? 'is-danger' : ''"
    >
      <b-select v-model="fields.model.value" expanded>
        <option value="" disabled>Choisir un modèle</option>
        <option v-for="model in Object.keys(queclinkModels)" :key="model" :value="model">
          {{ queclinkModels[model] }}
        </option>
      </b-select>
    </b-field>
    <b-field
      label="Usure"
      :message="fields.wear.error"
      :type="fields.wear.error !== null ? 'is-danger' : ''"
    >
      <b-select v-model="fields.wear.value" expanded>
        <option v-for="wear in wears" :key="wear.value" :value="wear.value">
          {{ wear.label }}
        </option>
      </b-select>
    </b-field>
    <b-field
      label="Commentaire"
      :message="fields.comment.error"
      :type="fields.comment.error !== null ? 'is-danger' : ''"
    >
      <b-input v-model="fields.comment.value" type="textarea" />
    </b-field>
    <hr />
    <b-field>
      <b-button
        native-type="submit"
        type="is-primary"
        :loading="loading"
        :disabled="loading || isInvalid"
      >
        Ajouter
      </b-button>
    </b-field>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { format } from 'date-fns'
import { capitalize } from '@helpers/capitalize'
import { OWNERS } from '@constants/tracker/owner.js'
import { QUECLINK_MODELS } from '@constants/tracker/model.js'
import { WEARS } from '@constants/tracker/wear.js'

export default {
  name: 'AddQueclinkTrackerForm',

  data() {
    return {
      loading: false,
      fields: {
        number: {
          value: '',
          error: null,
        },
        imei: {
          value: '',
          error: null,
        },
        purchasedAt: {
          value: null,
          error: null,
        },
        owner: {
          value: '',
          error: null,
        },
        model: {
          value: '',
          error: null,
        },
        wear: {
          value: 0,
          error: null,
        },
        comment: {
          value: '',
          error: null,
        },
      },
    }
  },

  created() {
    this.owners = OWNERS
    this.queclinkModels = QUECLINK_MODELS
    this.wears = WEARS
  },

  computed: {
    isInvalid() {
      return (
        !this.fields.number.value ||
        !this.fields.imei.value ||
        !this.fields.purchasedAt.value ||
        !this.fields.owner.value ||
        !this.fields.model.value
      )
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async submit() {
      this.loading = true

      try {
        const queclinkTracker = await this.$services.queclinkTrackerService.create({
          number: this.fields.number.value,
          imei: this.fields.imei.value,
          purchasedAt: this.fields.purchasedAt.value,
          comment: this.fields.comment.value,
          owner: this.fields.owner.value,
          model: this.fields.model.value,
          wear: this.fields.wear.value,
        })

        this.addToastMessage({
          text: `Le tracker Queclink ${queclinkTracker.number} a été ajouté.`,
          type: 'is-success',
        })

        this.$router.push({
          name: 'queclinkTracker.edit',
          params: { id: queclinkTracker.id },
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ?? 'La création du tracker Queclink a échouée.',
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },

    dateFormat(date) {
      return format(date, 'dd/MM/yyyy')
    },

    capitalize(value) {
      return capitalize(value)
    },
  },
}
</script>
